import { render, staticRenderFns } from "./ContoList.vue?vue&type=template&id=1d0baa65&"
import script from "./ContoList.vue?vue&type=script&lang=ts&"
export * from "./ContoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports